import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5ab03e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-id"]
const _hoisted_2 = { class: "open-orders-item-mobile__header" }
const _hoisted_3 = { class: "open-orders-item-mobile__market-info" }
const _hoisted_4 = { class: "open-orders-item-mobile__market-name" }
const _hoisted_5 = { class: "open-orders-item-mobile__details" }
const _hoisted_6 = { class: "open-orders-item-mobile__column" }
const _hoisted_7 = { class: "open-orders-item-mobile__row" }
const _hoisted_8 = { class: "open-orders-item-mobile__label" }
const _hoisted_9 = { class: "open-orders-item-mobile__value" }
const _hoisted_10 = { class: "open-orders-item-mobile__row" }
const _hoisted_11 = { class: "open-orders-item-mobile__label" }
const _hoisted_12 = { class: "open-orders-item-mobile__value" }
const _hoisted_13 = { class: "open-orders-item-mobile__row" }
const _hoisted_14 = { class: "open-orders-item-mobile__label" }
const _hoisted_15 = { class: "open-orders-item-mobile__value" }
const _hoisted_16 = { class: "open-orders-item-mobile__column" }
const _hoisted_17 = { class: "open-orders-item-mobile__row" }
const _hoisted_18 = { class: "open-orders-item-mobile__label" }
const _hoisted_19 = { class: "open-orders-item-mobile__row" }
const _hoisted_20 = { class: "open-orders-item-mobile__label" }
const _hoisted_21 = { class: "open-orders-item-mobile__value" }
const _hoisted_22 = { class: "open-orders-item-mobile__row" }
const _hoisted_23 = { class: "open-orders-item-mobile__label" }
const _hoisted_24 = { class: "open-orders-item-mobile__value" }

import { OtIcon, OtLozenge, OtNumberDisplay } from '@1trading/design-system';
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { MarketType } from '@exchange/libs/market/service/src/lib/market-model';
import OrderStatus from '@exchange/libs/order/shared-components/src/lib/OrderStatus.vue';
import TimeFromNow from '@exchange/libs/order/shared-components/src/lib/TimeFromNow.vue';
import { MyOrdersListType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';
import { toastManagerInstance, OrderCancelFailedToast } from '@exchange/libs/toasts/src';

import useOrder from '../../useOrder';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenOrdersItemMobile',
  props: {
  cancelOrder: { type: Function as PropType<(id: string) => Promise<void>>, required: true },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
},
  setup(__props) {

const { t } = useI18n({ useScope: 'global' });

const props = __props;

const listType = MyOrdersListType.open;
const { animation, market } = useOrder(props.order, listType);

const isFutures = computed(() => market.value?.type === MarketType.PERP);

const sideDisplay = computed(() => {
  if (isFutures.value) {
    return props.order.isBuy
      ? `${t('fundamentals.orders.side.buy')} / ${t('fundamentals.orders.side.long')}`
      : `${t('fundamentals.orders.side.sell')} / ${t('fundamentals.orders.side.short')}`;
  }
  return props.order.isBuy ? t('fundamentals.orders.side.buy') : t('fundamentals.orders.side.sell');
});

const orderItemClasses = computed(() => ({
  'status-open': props.order.status === 'OPEN',
  'status-triggered': props.order.status === 'STOP_TRIGGERED',
  'status-filled': props.order.status === 'FILLED',
  'status-filled-closed': props.order.status === 'FILLED_CLOSED',
  'status-filled-fully': props.order.status === 'FILLED_FULLY',
  'status-closing': props.order.status === 'CLOSING',
  'status-closed': props.order.status === 'CLOSED',
  'status-rejected': props.order.status === 'REJECTED',
  'status-filled-rejected': props.order.status === 'FILLED_REJECTED',
  'status-failed': props.order.status === 'FAILED',
}));

const handleCancelOrder = () =>
  props.cancelOrder(props.order.id).catch((error) =>
    toastManagerInstance.addToast({
      content: OrderCancelFailedToast,
      props: {
        errorCode: error.data ? error.data.error : undefined,
      },
    }),
  );

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["open-orders-item-mobile", orderItemClasses.value]),
    "data-id": __props.order.id,
    style: _normalizeStyle({ 'animation-name': _unref(animation) })
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.order.marketName), 1),
        (isFutures.value)
          ? (_openBlock(), _createBlock(_unref(OtLozenge), {
              key: 0,
              filled: false,
              text: _ctx.$t('fundamentals.perpetual.short'),
              class: "open-orders-item-mobile__lozenge"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createVNode(OrderStatus, {
          class: "open-orders-item-mobile__status",
          order: __props.order,
          market: _unref(market)
        }, null, 8, ["order", "market"])
      ]),
      _createVNode(_component_x_button, {
        class: "open-orders-item-mobile__cancel-button",
        size: "3xs",
        variant: "tertiary",
        onClick: handleCancelOrder
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtIcon), { name: "close-square" })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('modules.myOrders.header.time')) + ":", 1),
          _createElementVNode("span", _hoisted_9, [
            (__props.order.time)
              ? (_openBlock(), _createBlock(TimeFromNow, {
                  key: 0,
                  date: __props.order.time,
                  "force-absolute-time": true
                }, null, 8, ["date"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('modules.myOrders.header.amount')) + ":", 1),
          _createElementVNode("span", _hoisted_12, [
            _createVNode(_unref(OtNumberDisplay), {
              number: __props.order.amount,
              precision: __props.order.getAmountPrecision(_unref(market)),
              suffix: __props.order.amountSuffix
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('modules.myOrders.header.total')) + ":", 1),
          _createElementVNode("span", _hoisted_15, [
            _createVNode(_unref(OtNumberDisplay), {
              number: __props.order.displayTotal,
              precision: __props.order.getTotalPrecision(_unref(market)),
              suffix: __props.order.quoteCurrencyCode
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('modules.myOrders.header.side')) + ":", 1),
          _createElementVNode("span", {
            class: _normalizeClass(["open-orders-item-mobile__value", { buy: __props.order.isBuy, sell: !__props.order.isBuy }])
          }, _toDisplayString(sideDisplay.value), 3)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('modules.myOrders.header.priceShort')) + ":", 1),
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_unref(OtNumberDisplay), {
              number: __props.order.displayPrice,
              precision: __props.order.getMarketPrecision(_unref(market)),
              suffix: __props.order.priceSuffix
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('modules.myOrders.header.filled')) + ":", 1),
          _createElementVNode("span", _hoisted_24, _toDisplayString(__props.order.filledAmount) + " " + _toDisplayString(__props.order.amountSuffix) + " / " + _toDisplayString(__props.order.filledPercent) + "%", 1)
        ])
      ])
    ])
  ], 14, _hoisted_1))
}
}

})